export default defineComponent({
  inheritAttrs: false,
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  }
});